module.exports = __webpack_public_path__ + "static/sol4-a446cfa2f3b44956b438ba2ca2c1595f.png";